import AccordionRow from './AccordionRow';

export default AccordionRow;
